/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable } from '@angular/core';
import { BsZIndexService } from '@well/iriro-frontend-libs/bs-component-store';
import { PrimeNG } from 'primeng/config';
import { ZIndexUtils } from 'primeng/utils';

/**
 * PrimeNG-backed z-index service implementation.
 * Delegates to PrimeNG's ZIndexUtils so that bs-autocomplete
 * participates in PrimeNG's dynamic z-index stacking.
 */
@Injectable()
export class PrimeNgZIndexService implements BsZIndexService {
  private primeNG = inject(PrimeNG);

  set(key: string, el: HTMLElement, baseZIndex: number): void {
    const categoryZIndex = (this.primeNG.zIndex as Record<string, number>)[key]
      ?? this.primeNG.zIndex.overlay;
    ZIndexUtils.set(key, el, baseZIndex + categoryZIndex);
  }

  clear(el: HTMLElement): void {
    ZIndexUtils.clear(el);
  }

  getCurrent(): number {
    return ZIndexUtils.getCurrent();
  }
}
